import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useScrollToTop } from "@/hooks/useScrollToTop";
import ContactSection from "@/pages/home/components/ContactSection";

export default function Contact() {
  useScrollToTop();
  return (
    <div className="min-h-screen bg-brand-cream font-sans">
      <Navbar />
      <main className="pt-0">
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}